// projects/humanresources-common-shared/assets/i18n/*/hr-constraint-exception.json
export class HrConstraintExceptionKey {
    private static readonly keyPrefix = 'hrConstraintException';
    public static prefix = `${HrConstraintExceptionKey.keyPrefix}.`;
}
